<template>
  <div></div>
</template>

<style lang="scss" scoped>
  .form-create-member {
    margin: 0 auto;
    padding: 25px;
  }
</style>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import VueQrcode from 'vue-qrcode';
import { MEMBER_LOGIN } from '@/core/services/store/member.auth.module';
import EventDetails from '@/view/pages/members/public/EventDetails.vue';
import messageParent from '@/core/services/messageParent';
import FamilyTable from '@/view/components/FamilyTable.vue';
import ParentsTable from '@/view/components/ParentsTable.vue';
import PaymentComplete from '@/view/components/PaymentComplete.vue';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'profile-details',
  components: {
    VueQrcode,
    EventDetails,
    FamilyTable,
    ParentsTable,
    PaymentComplete
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['isMemAuthenticated', 'currentMember']),
    
  },
  async mounted() {
    this.route_member_id = this.$route.params.member_id;
    this.route_token = this.$route.params.token;
  },
  data() {
    return {
      route_member_id: null,
      route_token: null,
    };
  },
  watch: {
    
  },
  methods: {
    
    async loadClientToken() {

      let res = await axios.post('/member/token', { login_token: this.route_token });
      if (res.status == 200) {
          this.$store.dispatch(MEMBER_LOGIN, res.data);

          this.$store.dispatch(MEMBER_LOGIN, {
            member: res.data,
            token: res.data.token,
            company: res.data.company
          });

          location.href = '/profile';

          setTimeout(function(){
            messageParent(JSON.stringify({ height: document.body.scrollHeight }));
          }, 300);
          
      } else {
        console.error("error : ", res);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta medlemsdata');
      }
    },
  }
};
</script>
